var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalBasedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0356 4.43943C14.076 3.47981 13.5962 3 13 3C12.4037 3 11.924 3.47981 10.9643 4.43943C10.3885 5.01528 9.81784 5.28263 8.99687 5.28263C8.28004 5.28263 7.26019 5.1436 6.7 5.7085C6.14424 6.26893 6.28265 7.28458 6.28265 7.99685C6.28265 8.81785 6.01528 9.38849 5.43941 9.96435C4.47981 10.924 4.00001 11.4037 4 12C4.00002 12.5962 4.47983 13.076 5.43944 14.0356C6.08454 14.6807 6.28265 15.0973 6.28265 16.0031C6.28265 16.72 6.14363 17.7398 6.70854 18.3C7.26896 18.8557 8.28461 18.7173 8.99685 18.7173C9.87114 18.7173 10.2922 18.8883 10.9161 19.5123C11.4474 20.0437 12.1597 21 13 21C13.8403 21 14.5526 20.0437 15.0839 19.5123C15.7078 18.8883 16.1289 18.7173 17.0031 18.7173C17.7154 18.7173 18.731 18.8557 19.2914 18.3M19.2914 18.3C19.8564 17.7398 19.7173 16.72 19.7173 16.0031C19.7173 15.0973 19.9154 14.6807 20.5605 14.0356C21.5202 13.076 22 12.5962 22 12C22 11.4037 21.5202 10.924 20.5605 9.96435M19.2914 18.3H19.3",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84998 9.75039L13 12.9004L21.1002 3.90039",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalBasedIc);
export default __webpack_public_path__ + "static/media/approval_based_ic.f3a0acaa6c0904d7b0180b2e17cca71d.svg";
export { ForwardRef as ReactComponent };